import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintApiManager: FootprintApiManager_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
